/* candy-product-recent.js — the Recently Viewed row.
   Split out of the one candy-product.js IIFE (2026-09). The LIST lives in
   candy-product-core.js because it is page state; this module only paints it.

   2026-09-08, client: "Recently Viewed is showing full product cards with prices and plus
   buttons. It should be a slim row of circular thumbnails, navigation only, no price, no
   quick add." So this no longer rebuilds snippets/candy-bsl3k-card.liquid in JS. Each entry
   is a link, a round photo and the product name — nothing that adds to cart, quotes a price
   or opens the size popup. The rail engine (CP.rails) and the money formatter go with the
   cards: the row is a plain flex strip that scrolls natively when it overflows.
   Styles: assets/candy-recent-circles.css. */
(function(){
  if(!window.CandyPrd) return;
  var CP = window.CandyPrd;
  CP.ready('.custom-prd7k9[data-prd-part="recent"]', function(root){
    var box  = root.querySelector('[data-recent]');
    var grid = root.querySelector('[data-recent-grid]');
    var others = CP.recentOthers();     /* the PRE-write list, cached in the core */
    if(!box || !grid || !others.length) return;

    var attr = function(s){
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    };

    var html = '';
    others.slice(0, 8).forEach(function(x){
      /* An entry with no photo would be an empty disc, which reads as broken rather than as
         history — skip it. Everything else the old card used (price, variants, badge, the
         category/texture chips) is simply not read any more. */
      if(!x.i || !x.u) return;
      html += '<a class="custom-rvw2c__item" href="' + attr(x.u) + '">' +
                '<span class="custom-rvw2c__ring">' +
                  /* the photo sits in its own clipped disc so hover can zoom the picture inside a
                     circle that does not move - see candy-recent-circles.css */
                  '<span class="custom-rvw2c__disc">' +
                    '<img class="custom-rvw2c__img" src="' + attr(x.i) + '" alt="" loading="lazy" decoding="async"/>' +
                  '</span>' +
                '</span>' +
                '<span class="custom-rvw2c__name">' + attr(x.t) + '</span>' +
              '</a>';
    });
    if(!html) return;

    grid.innerHTML = html;
    box.hidden = false;

    /* ---- DRAG TO SCROLL ----
       The row holds all 8 of the history, and at the circle size the client asked for that is
       wider than the page on a desktop. It briefly showed only 7 so it would fit; hiding a
       product to avoid a scrollbar is the wrong trade, so the row scrolls instead and this makes
       it draggable — the same mouse-drag-with-momentum the collection page's story circles have
       (see candy-collection.js), so the two circle rails behave identically. Touch already pans
       natively; this is only for a mouse.
       The grab cursor is only applied when the row actually overflows, so a short history that
       fits on the line does not pretend to be draggable. */
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var navrow = root.querySelector('[data-recent-nav]');
    var dotbox = root.querySelector('[data-recent-dots]');
    var prev = root.querySelector('.custom-rvw2c__nav--prev');
    var next = root.querySelector('.custom-rvw2c__nav--next');

    var over = function(){ return grid.scrollWidth > grid.clientWidth + 1; };

    /* ---- arrows + dots (client 2026-09-08: "add arrows and dots like this") ----
       ONE DOT PER SCREENFUL, not per product. The rail the client pointed at focuses one card at
       a time, so there a dot per card is also a dot per position. This row shows about five
       circles at once, so a dot per product would have had eight dots for two reachable
       positions - the client's "dots count is not correct". Pages are what the row can actually
       be in: ceil(scrollWidth / clientWidth), which is 2 on a desktop and 3 on a phone, and
       every one of them is reachable by an arrow, a dot or a drag. The pill styling is the same
       as that rail's, down to the 0.625vw dot growing into a 2.0833vw gradient bar.
       Everything is hidden while the whole row fits - no dead controls. */
    var pages = function(){ return Math.max(1, Math.ceil(grid.scrollWidth / grid.clientWidth - 0.02)); };
    var travel = function(){ return Math.max(0, grid.scrollWidth - grid.clientWidth); };
    /* the page is read off how far along the TRAVEL the row is, not off scrollLeft / clientWidth.
       The last page is a part-page - eight circles overhang the viewport by 545px at 1600, not by
       a whole 1378 - so dividing by the viewport rounded to 0 at both ends and the live dot never
       moved. Mapping 0..travel onto 0..pages-1 lights the last dot exactly at the end. */
    var page = function(){
      var n = pages(), t = travel();
      if(n < 2 || t <= 0) return 0;
      /* the epsilon matters at the resting position: the row starts at the MIDDLE of its travel
         (see centre() below), which with two stops is exactly 0.5 - and Math.round(0.5) is 1, so
         the row would load with its second dot already lit. Nudging it down means the first dot
         holds until the row is genuinely past halfway. */
      return Math.round(grid.scrollLeft / t * (n - 1) - 0.001);
    };

    var dots = [];
    var buildDots = function(){
      var n = pages();
      if(dots.length === n) return;
      dotbox.innerHTML = '';
      dots = [];
      for(var i = 0; i < n; i++){
        (function(i){
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'custom-rvw2c__dot';
          d.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + n);
          d.addEventListener('click', function(){
            var t = travel(), last = pages() - 1;
            grid.scrollTo({ left: last > 0 ? i / last * t : 0, behavior: reduce ? 'auto' : 'smooth' });
          });
          dotbox.appendChild(d);
          dots.push(d);
        })(i);
      }
    };

    var sync = function(){
      var on = over();
      grid.classList.toggle('custom-rvw2c__row--pan', on);
      navrow.hidden = !on;
      dotbox.hidden = !on;
      if(!on) return;
      buildDots();
      var cur = page();
      dots.forEach(function(d, i){ d.classList.toggle('is-on', i === cur); });
      prev.disabled = grid.scrollLeft <= 1;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
    };

    /* a screenful at a time, like the rail the client pointed at - not one circle, which on a
       row this wide barely moved */
    var step = function(dir){
      grid.scrollBy({ left: dir * grid.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function(){ step(-1); });
    next.addEventListener('click', function(){ step(1); });

    var tick = 0;
    grid.addEventListener('scroll', function(){
      if(tick) return;
      tick = requestAnimationFrame(function(){ tick = 0; sync(); });
    });
    /* ---- REST IN THE MIDDLE (client 2026-09-08: "centered and left right equal slides same like
       above") ----
       The row used to load at scrollLeft 0, so the left edge showed the page's full 6.9444vw
       gutter while the right edge had a circle running off the screen - the two sides did not
       match. The rail the client is comparing it to is an endless ring, which always has a part
       card at both edges; a finite row can only do that by resting halfway along its travel.
       The content is symmetrical, so half the overflow then hangs off each side and the two edges
       are cut by exactly the same amount. Everything stays reachable - the arrows, the dots and
       the drag all still run from one end to the other. */
    var centre = function(){
      var t = travel();
      if(t > 0) grid.scrollLeft = t / 2;
    };
    window.addEventListener('resize', function(){ dots = []; sync(); centre(); sync(); });
    sync();
    centre();
    sync();

    var down = false, startX = 0, startL = 0, moved = false, vel = 0, lastX = 0, lastT = 0, raf = 0;
    grid.addEventListener('dragstart', function(e){ e.preventDefault(); });
    grid.addEventListener('mousedown', function(e){
      if(grid.scrollWidth <= grid.clientWidth + 1) return;
      down = true; moved = false;
      startX = e.clientX; startL = grid.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); vel = 0;
      if(raf){ cancelAnimationFrame(raf); raf = 0; }
      grid.classList.add('custom-rvw2c__row--drag');
    });
    window.addEventListener('mousemove', function(e){
      if(!down) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 5) moved = true;
      grid.scrollLeft = startL - dx;
      var now = performance.now(), dt = now - lastT;
      if(dt > 0){ vel = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = now; }
    });
    window.addEventListener('mouseup', function(){
      if(!down) return;
      down = false;
      grid.classList.remove('custom-rvw2c__row--drag');
      var v = vel * 16;                     /* px per ~60fps frame at release */
      if(Math.abs(v) > 1 && !reduce){
        var glide = function(){
          grid.scrollLeft -= v;
          v *= 0.94;
          if(Math.abs(v) > 0.4) raf = requestAnimationFrame(glide); else raf = 0;
        };
        raf = requestAnimationFrame(glide);
      }
    });
    /* a real drag must not fire the link it ends on */
    grid.addEventListener('click', function(e){
      if(!moved) return;
      e.preventDefault(); e.stopPropagation();
      moved = false;
    }, true);
  });
})();
